if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    connectedCallback() {
      if (this.dataset.scrollingInitialized === 'true') return;

      this.promotion = this.querySelector('.promotion');
      if (!this.promotion) return;

      if (window.BewoTheme?.config?.motionReduced) return;

      this.init();
    }

    init() {
      if (this.dataset.scrollingInitialized === 'true') return;
      if (this.childElementCount !== 1 || !this.promotion) return;

      this.dataset.scrollingInitialized = 'true';
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.appendChild(this.promotion.cloneNode(true));
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        { rootMargin: '0px 0px 50px 0px' }
      );

      observer.observe(this);

      const rect = this.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        this.scrollingPlay();
      }
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
